module.exports = __webpack_public_path__ + "static/media/meal_selected.346faaaf.svg";